import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
export function withTooltip(item, toolTipText, key, where) {
    if (where === void 0) { where = 'top'; }
    var overlay = React.createElement(Tooltip, { id: "tooltip-".concat(key) }, toolTipText);
    return (React.createElement(OverlayTrigger, { key: key, placement: where, overlay: overlay }, item));
}
export function limitedString(text, limit) {
    if (limit === void 0) { limit = 5; }
    if (text.length > limit) {
        var croppedText = text.slice(0, limit) + '...';
        return withTooltip(React.createElement("span", null, croppedText), text, text);
    }
    return text;
}
//# sourceMappingURL=app-utils.js.map